ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}
ProductReviews.Views.Widget ?= {}
ProductReviews.Templates ?= {}

ProductReviews.Templates['product_reviews_widget_review_rating'] = require '../../widget_review_rating.html.mustache'

class ProductReviews.Views.Widget.Review
  constructor: ({@data, @uuid, @$el}) ->

  prepareData: ->
    return unless @data?.averageRating and @data.ratingCount

    rating = @data.averageRating
    stars = []
    bhc = "deal-review-rating:#{rating}"
    for position in [1..5]
      starType = switch
        when rating > 7/8
          'full-star'
        when rating > 5/8
          'three-fourth-star'
        when rating > 3/8
          'half-star'
        when rating > 1/8
          'fourth-star'
        else
          'empty-star'
      stars.push "<span class='#{starType} icon-star-filled'></span>"
      rating--

    productRating:
      bhc:
        rating: "review-rating:#{@uuid}_#{@data.averageRating.toFixed(1)}"
        ratingCount: "rating-count:#{@uuid}_#{@data.ratingCount}"
      count: I18n.toNumber @data.ratingCount
      stars: stars

  render: ->
    @$el.find('.deal-title').after ProductReviews.Templates['product_reviews_widget_review_rating'].render(@prepareData())


module.exports = ProductReviews.Views.Widget.Review
